import { render, staticRenderFns } from "./McnAccountAuth.vue?vue&type=template&id=5195ee05&scoped=true"
import script from "./McnAccountAuth.vue?vue&type=script&lang=js"
export * from "./McnAccountAuth.vue?vue&type=script&lang=js"
import style0 from "./McnAccountAuth.vue?vue&type=style&index=0&id=5195ee05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5195ee05",
  null
  
)

export default component.exports